export default "__VITE_ASSET__C7X3Hu6M__"